import { IGameAttendances } from "@grassrootly/api";
import { Div, Icon, Label } from "@grassrootly/rn-core";
import { Image, ScrollView } from "react-native";
import { images } from "../../../layout/assets";

export default function PreGameAttendees({ attendees }: { attendees: IGameAttendances[] }) {
  return (
    <Div classNames={["flex1", "pt-{24}"]}>
      {/* <Label type="l1Bold" classNames={["colorPrimaryMain", "ml-{16}", "mb-{10}"]}>
        Who's balling & who's not?
      </Label> */}
      <Div classNames={["flexRow", "ph16", "mb-{16}"]}>
        <Label type="l3Regular" classNames={["mr-{5}"]}>
          {attendees.filter((a) => a.attended).length}
        </Label>
        <Icon name="check" classNames={["colorSuccessMain"]} />
        <Label type="l3Regular" classNames={["mr-{5}", "ml-{30}"]}>
          {attendees.filter((a) => a.attended == false).length}
        </Label>
        <Icon name="close" classNames={["colorDangerMain"]} />
        <Label type="l3Regular" classNames={["mr-{5}", "ml-{30}"]}>
          {attendees.filter((a) => a.attended == null).length}
        </Label>
        <Label type="l3Regular" classNames={["colorNeutralLighterDark"]}>
          pending
        </Label>
      </Div>

      <ScrollView style={{ flex: 1 }}>
        {attendees.map((attendee, index) => (
          <Div
            key={index}
            classNames={[
              "p16",
              index % 2 == 0 ? "bgNeutralDarkerMain" : "bgSecondaryMain",
              "flexRow",
              "alignItemsCenter",
            ]}
          >
            <Image
              style={{ height: 40, width: 40, borderRadius: 40 }}
              resizeMode="cover"
              source={
                attendee.player?.profile_picture ? { uri: attendee.player?.profile_picture } : images.playerAvatar
              }
            />
            <Label classNames={["ml-{15}"]}>{attendee.player?.name}</Label>
            <Div classNames={["ml-{auto}"]}>
              {attendee.attended ? <Icon name="check" classNames={["colorSuccessMain"]} /> : null}
              {attendee.attended == null ? (
                <Label type="l3Regular" classNames={["colorNeutralLighterDark"]}>
                  pending
                </Label>
              ) : null}
              {attendee.attended == false ? <Icon name="close" classNames={["colorDangerMain"]} /> : null}
            </Div>
          </Div>
        ))}
      </ScrollView>
    </Div>
  );
}
